import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_RS.json';
import exercises from './PILATES_EXERCISES_RS.json';
import recipes from './PILATES_RECIPES_RS.json';

export const PILATES_DATA_RS: ServiceData = {
  articles,
  exercises,
  recipes,
};
